angular.module("app").controller('BannersListPageController', [
    '$scope',
    'preloadedBanners',
    '$state',
    'pagesService',
    'logger',
    'errorHandler',
    function ($scope, preloadedBanners, $state, pagesService, logger, errorHandler) {
        $scope.banners = preloadedBanners.pages;

        $scope.editPage = function (page, showMain, hasItems) {
            if (!showMain) {
                return $state.go("main.pages.editDetailed", {pageId: page.id, showMain: !!showMain, hasItems: !!hasItems});
            }
            $state.go("main.pages.edit", {pageId: page.id, showMain : showMain, hasItems: hasItems});
        };

        $scope.deletePage = function (page) {
            pagesService.deletePage(page.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(page);
                        logger.logSuccess("global.successfullyDeleted");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        function spliceFromList (page) {
            var index = $scope.banners.indexOf(page);
            if (index != -1) {
                $scope.banners.splice(index, 1);
            }
        }
    }
]);